import React, { useEffect, useRef, useState } from "react";
import { useReveal } from "../../hooks/use-reveal";

// Parses strings like "30-50%", "$10M+", "< 5min", "99.9%", "24/7" and
// animates the leading numeric portion while preserving the rest verbatim.
function parseValue(raw) {
  const match = String(raw).match(/-?\d+(\.\d+)?/);
  if (!match) return null;
  const num = parseFloat(match[0]);
  const prefix = raw.slice(0, match.index);
  const suffix = raw.slice(match.index + match[0].length);
  const decimals = match[0].includes(".") ? match[0].split(".")[1].length : 0;
  return { num, prefix, suffix, decimals };
}

export const CountUp = ({ value, duration = 1400, className = "" }) => {
  const { ref, visible } = useReveal();
  const [display, setDisplay] = useState(value);
  const started = useRef(false);

  useEffect(() => {
    if (!visible || started.current) return;
    started.current = true;

    const parsed = parseValue(value);
    if (!parsed) {
      setDisplay(value);
      return;
    }

    const { num, prefix, suffix, decimals } = parsed;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = num * eased;
      setDisplay(`${prefix}${current.toFixed(decimals)}${suffix}`);
      if (progress < 1) requestAnimationFrame(tick);
      else setDisplay(value);
    };

    requestAnimationFrame(tick);
  }, [visible, value, duration]);

  return (
    <span ref={ref} className={className}>
      {display}
    </span>
  );
};
